import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { UserHubNotification } from '@models/notification.model';
import { NotificationsUserActions } from '@store/actions/notifications/notifications.actions';

export interface NotificationUserViewModalData {
  notification: UserHubNotification;
  isArchived: boolean;
}

@Component({
  selector: 'app-notification-user-view-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
  ],
  templateUrl: './notification-user-view-modal.component.html',
  styleUrl: './notification-user-view-modal.component.css',
})
export class NotificationUserViewModalComponent {
  private readonly store = inject(Store);
  readonly dialogRef = inject(MatDialogRef<NotificationUserViewModalComponent>);
  readonly data = inject<NotificationUserViewModalData>(MAT_DIALOG_DATA);

  get notification(): UserHubNotification { return this.data.notification; }
  get isArchived(): boolean { return this.data.isArchived; }

  formatDate(dateStr: string | undefined): string {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('T')[0].split('-').map(Number);
    const d = new Date(year, month - 1, day);
    return d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  }

  onMarkAsRead(): void {
    this.store.dispatch(NotificationsUserActions.markNotificationRead({ id: this.notification.id }));
    this.dialogRef.close();
  }

  onMarkAsUnread(): void {
    this.store.dispatch(NotificationsUserActions.markNotificationUnread({ id: this.notification.id }));
    this.dialogRef.close();
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
